/* eslint-disable one-var, one-var-declaration-per-line */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {_} from 'utils/i18n';
import {getRemainingLabel, minutesSinceMidnight} from 'utils/time';

import {Entry} from '../Banner';

const Title = _('Experience Sampling');

const ExperienceSamplingEntry = ({end, url, questionnaire: {name}, now}) => (
    <Entry
        className="current-sampling"
        title={Title}
        message={name}
        time={getRemainingLabel((end - minutesSinceMidnight(now)) * 60 * 1000)}
        url={url}
    />
);

ExperienceSamplingEntry.propTypes = {
    end: PropTypes.number.isRequired,
    now: PropTypes.instanceOf(Date).isRequired,
    url: PropTypes.string.isRequired,
    questionnaire: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
};

const mapStateToProps = ({experiencesampling: {questionnaires}}, {id}) => ({
    ...questionnaires[id],
});

export default connect(mapStateToProps)(ExperienceSamplingEntry);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/ExperienceSamplingBanner/Entry.js